

import Home from './components/Home.vue'
import Contact from './components/Contact.vue'
import About from './components/About.vue'
import Services from './components/Services.vue'
import AgendarCita from './components/AgendarCita.vue'
import Terminos from './components/TerminosCondiciones.vue'
import VideosGallery from './components/videos.vue'
import Gallery from './components/Carrusel.vue'
import PointsRecolection from './components/ubicaciones.vue'


const routes = [
    {
        path: '/puntos_de_recoleccion',
        component: PointsRecolection,
    },
    {
        path: '/videos',
        component: VideosGallery,
    },
    {
        path: '/galeria',
        component: Gallery,
    },
    {
        path: '/',
        component: Home,
    },
    {
        path:'/acerca_de',
        component: About,
    },
    {
        path:'/contacto',
        component: Contact,
    },
    {
        path: '/servicios',
        component: Services,
    },
    {
        path:'/agendar_cita',
        component: AgendarCita,
    },
    {
        path: '/terminos',
        component: Terminos,
    },

]


export default routes